import { render } from "./AttachmentViewer.vue?vue&type=template&id=3273abb2&scoped=true&ts=true"
import script from "./AttachmentViewer.vue?vue&type=script&lang=ts"
export * from "./AttachmentViewer.vue?vue&type=script&lang=ts"

import "./AttachmentViewer.vue?vue&type=style&index=0&id=3273abb2&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3273abb2"]])

export default __exports__